import React from "react";
import AuthHeader from "components/common/AuthHeader";
import MyMeetingsBody from "components/MyMeetings/MyMeetingsBody/MyMeetingsBody";

const MyMeetings = () => {
  return (
    <>
      <AuthHeader />

      <MyMeetingsBody />
    </>
  );
};

export default MyMeetings;
